import { CloseIcon, ExpandIcon } from "@/components/appIcons";

interface SelectTriggerActionProps {
  clearable: boolean;
  onClear: (event: React.MouseEvent<HTMLSpanElement>) => void;
}

export function SelectTriggerAction({ clearable, onClear }: SelectTriggerActionProps) {
  if (clearable) {
    return (
      <span
        role="button"
        onClick={onClear}
        className="ml-auto shrink-0 rounded-full p-0.5 transition-colors hover:bg-foreground/10"
      >
        <CloseIcon className="size-3.5" />
      </span>
    );
  }

  return <ExpandIcon className="ml-auto size-4 shrink-0 text-muted-foreground" />;
}
